import React from 'react';
import { motion } from 'framer-motion';
import { Truck, CheckCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';

const RoadFreight = () => {
  const services = [
    'Dedicated express vehicles',
    'UK mainland coverage',
    'European road network',
    'Same-day and next-day delivery',
    'Temperature-controlled transport',
    'High-value goods security',
    'Real-time GPS tracking',
    'Proof of delivery documentation',
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO title="UK & European Express Road Freight | Aero Time Critical" description="Dedicated express vans, full and part loads, time-definite delivery, temperature-controlled and secure high-value road freight across the UK and Europe." path="/road-freight" />
      <PageHero
        badge="GROUND TRANSPORTATION"
        BadgeIcon={Truck}
        title="Road Freight"
        titleAccent="Services"
        description="Dedicated express vehicles for time-definite delivery across the UK and Europe with secure handling and full tracking visibility."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/arxcdav1_Road%20Freight.jpg"
      />

      <section className="bg-[#F7F9FB] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/arxcdav1_Road%20Freight.jpg"
                alt="Express road freight trucks in transit across the UK and Europe"
                className="w-full h-[450px] object-cover rounded-lg shadow-xl"
                loading="lazy"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-[#0089D0] font-semibold tracking-wide uppercase text-sm">Reliable Ground Transport</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-8 text-[#003057]">
                UK & European Coverage
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {services.map((service, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-3"
                  >
                    <CheckCircle className="text-[#0089D0] flex-shrink-0" size={22} />
                    <span className="text-[#003057] font-medium">{service}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <CTASection
        title="Need Express Ground Transport?"
        description="Contact us for same-day or next-day delivery options"
        buttonText="Get Road Freight Quote"
      />
    </div>
  );
};

export default RoadFreight;
